module.exports = __webpack_public_path__ + "img/1792493415534.60a54752.png";